import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  knowledgeAreasLength: 0,
  knowledgeAreas: [],
  knowledgeArea: {},
  knowledgeAreaError: "",
  formError: "",
  formErrorJson: {},
};

export default function KnowledgeAreasReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_KNOWLEDGE_AREAS:
      return { ...state, loading: action.payload };
    case actions.LOADING_KNOWLEDGE_AREAS_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_KNOWLEDGE_AREAS:
      return { ...state, saveLoading: action.payload };
    case actions.GET_KNOWLEDGE_AREAS:
      return {
        ...state,
        knowledgeAreas: action.payload.knowledgeAreas,
        knowledgeAreasLength: action.payload.knowledgeAreasLength,
      };
    case actions.GET_KNOWLEDGE_AREAS_BY_ID:
      return {
        ...state,
        knowledgeArea: action.payload,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FORM_FAIL_JSON:
      return { ...state, formErrorJson: action.payload };
    case actions.KNOWLEDGE_AREAS_FAIL:
      return { ...state, knowledgeAreaError: action.payload };
    default:
      return state;
  }
}
